import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateSchedule } from '../../../../state';

const DayOfMonthEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentRecurringTask } = useAppSelector(state => state.recurringTask);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value === '' ? undefined : parseInt(event.target.value);
    dispatch(updateSchedule({ dayOfMonth: value }));
  };

  return (
    <TextField
      label="Day of Month"
      value={currentRecurringTask?.schedule?.dayOfMonth || ''}
      onChange={handleChange}
      size="small"
      type="number"
      sx={{ minWidth: 150 }}
      InputProps={{ inputProps: { min: 1, max: 31 } }}
      helperText="1-31 (last day if > days in month)"
    />
  );
};

export default DayOfMonthEdit;
